import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import type { GlobalSearchParams } from '@/modules/search/types';
import { searchService } from './search.service';
import { searchQueryKeys } from './search.query-key';

/** Below this length a search is noise — skip the fan-out entirely. */
export const MIN_SEARCH_LENGTH = 2;

export const searchQueryOptions = {
    global: (params: GlobalSearchParams) => queryOptions({
        queryKey: searchQueryKeys.query(params),
        queryFn:  () => searchService.search(params),
        // The caller passes the *debounced* term; only fire once it's meaningful.
        enabled:  params.q.trim().length >= MIN_SEARCH_LENGTH,
        // Keep the last hits on screen while the next term loads — no flicker.
        placeholderData: keepPreviousData,
        staleTime: 30_000,
    }),
};
